import React, { useState } from "react";
import { Wrapper } from "./AdditionalInformation.styled";
import { Alert, Space } from "antd";
import { Button, Upload, Input, TextArea, Row, Col, Form, Popover, Collapse, Select_ } from "components/common";
import { callGetApi, callPostApi } from "utils/api";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { getUser } from "utils/auth";

const AdditionalInformation = ({ next, prev, formData, setFormData, isSmall }) => {
    const user = getUser();
    const [isNoteFilled, setIsNoteFilled] = useState(false);
    const [isAllowedToSubmit, setIsAllowedToSubmit] = useState(false);
    const [isloading, setIsLoading] = useState(false);
    const [isCompanies, setIsCompanies] = useState([]);
    const [uitilityName, setUitilityName] = useState([]);

    const hanlde = (e) => {
        isCompanies.filter((el) => {
            if (e === el?.id) {
                setUitilityName(el);
            }
        });
    };

    const onFinish = (values) => {
        if (values?.notes) {
            setFormData({
                ...formData,
                notes: values?.notes,
                jan: values?.jan ? values?.jan : 0,
                feb: values?.feb ? values?.feb : 0,
                mar: values?.mar ? values?.mar : 0,
                apr: values?.apr ? values?.apr : 0,
                may: values?.may ? values?.may : 0,
                jun: values?.jun ? values?.jun : 0,
                jul: values?.jul ? values?.jul : 0,
                aug: values?.aug ? values?.aug : 0,
                sep: values?.sep ? values?.sep : 0,
                oct: values?.oct ? values?.oct : 0,
                nov: values?.nov ? values?.nov : 0,
                dec: values?.dec ? values?.dec : 0,
                averageMonthlyBill: values?.averageMonthlyBill == "" || values?.averageMonthlyBill == undefined ? 0 : Number(values?.averageMonthlyBill),
                yearlyUsage: values?.yearlyUsage == "" || values?.yearlyUsage == undefined ? 0 : Number(values?.yearlyUsage),
                utility_company: uitilityName?.name,
                utility_id: uitilityName?.id,
            });
            next();
        } else {
            if (isAllowedToSubmit) {
                setFormData({
                    ...formData,
                    notes: values?.notes,
                    jan: values?.jan ? values?.jan : 0,
                    feb: values?.feb ? values?.feb : 0,
                    mar: values?.mar ? values?.mar : 0,
                    apr: values?.apr ? values?.apr : 0,
                    may: values?.may ? values?.may : 0,
                    jun: values?.jun ? values?.jun : 0,
                    jul: values?.jul ? values?.jul : 0,
                    aug: values?.aug ? values?.aug : 0,
                    sep: values?.sep ? values?.sep : 0,
                    oct: values?.oct ? values?.oct : 0,
                    nov: values?.nov ? values?.nov : 0,
                    dec: values?.dec ? values?.dec : 0,
                    averageMonthlyBill: values?.averageMonthlyBill == "" || values?.averageMonthlyBill == undefined ? 0 : Number(values?.averageMonthlyBill),
                    yearlyUsage: values?.yearlyUsage == "" || values?.yearlyUsage == undefined ? 0 : Number(values?.yearlyUsage),
                    utility_company: uitilityName?.name,
                    utility_id: uitilityName?.id,
                });
                next();
            } else {
                setIsNoteFilled(true);
            }
        }
    };

    const uploadFile = (file) => {
        setIsLoading(true);
        const formFields = new FormData();
        formFields.append("file", file);
        callPostApi("/leads/upload/image/file", formFields, SuccessCall, FailCall);
    };

    const getUtilityCompany = () => {
        callGetApi(`/leads/get/utility/phx/gosolo/companies/${user?.locationId}`, onSuccessGetUtilityApi, onFailedGetUtilityApi);
    };

    const onSuccessGetUtilityApi = (data) => {
        setIsCompanies(data);
    };
    const onFailedGetUtilityApi = (err) => {
        console.log(err);
    };

    const SuccessCall = (data) => {
        setFormData({
            ...formData,
            utilPic: `${data.link}`,
        });
        setIsLoading(false);
    };

    const FailCall = () => {
        setIsLoading(false);
    };

    const handleChange = (info) => {
        if (info?.file?.status === "done" || info?.file?.status === "error") {
            uploadFile(info?.file?.originFileObj);
        }
    };

    // useEffect(() => {
    //   if (locationId_) {
    //     getUitilityApi();
    //   }
    // }, [locationId_]);

    useEffect(() => {
        getUtilityCompany();
    }, []);

    const { Panel } = Collapse;
    return (
        <Wrapper isSmall={isSmall}>
            <Form name="basic" initialValues={formData} onFinish={onFinish} autoComplete="off">
                <Collapse accordion>
                    <Panel className="header-container-background" header="Enter Monthly Usage">
                        <Row gutter={[10, 10]}>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="jan">
                                    <Input id="months" type="number" suffix="kwh" placeholder="January" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="feb">
                                    <Input id="months" type="number" suffix="kwh" placeholder="Feburary" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="mar">
                                    <Input type="number" id="months" suffix="kwh" placeholder="March" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="apr">
                                    <Input id="months" type="number" suffix="kwh" placeholder="April" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="may">
                                    <Input id="months" type="number" suffix="kwh" placeholder="May" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="jun">
                                    <Input id="months" type="number" suffix="kwh" placeholder="June" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="jul">
                                    <Input id="months" type="number" suffix="kwh" placeholder="July" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="aug">
                                    <Input id="months" type="number" suffix="kwh" placeholder="August" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="sep">
                                    <Input id="months" type="number" suffix="kwh" placeholder="September" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="oct">
                                    <Input id="months" type="number" suffix="kwh" placeholder="October" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="nov">
                                    <Input id="months" type="number" suffix="kwh" placeholder="November" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item className="border" name="dec">
                                    <Input id="months" type="number" suffix="kwh" placeholder="December" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Panel>

                    <Panel className="header-container-background" header="Enter Yearly Usage">
                        <Row>
                            <Col xs={24} md={12} lg={12} className="border">
                                <Form.Item name="yearlyUsage">
                                    <Input id="Annual-Usage" type="number" suffix="kwh" placeholder="Yearly Usage*" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Panel>

                    <Panel className="header-container-background" header="Enter Average Monthly Bill">
                        <Row>
                            <Col xs={24} md={12} lg={12} className="border">
                                <Form.Item name="averageMonthlyBill">
                                    <Input id="Annual-Usage" type="number" suffix="$" placeholder="Monthly Bill*" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Panel>
                </Collapse>

                <Row>
                    <Col span={24}>
                        <div className="line-container">
                            <div className="line-divider"></div>
                            <span className="line-text">
                                <span>OR</span>
                            </span>
                        </div>
                    </Col>
                </Row>
                <Row gutter={[15, 15]}>
                    <Col span={24}>
                        {!formData?.utilPic == "" ? (
                            <CheckCircleOutlined className="uploader-image" />
                        ) : (
                            <Form.Item
                                name="utilPic"
                                // rules={[
                                //   { required: true, message: "Please Enter this Field!" },
                                // ]}
                            >
                                <Upload showUploadList={false} onChange={handleChange}>
                                    <Button className="upload-btn-background-overlay" title="Upload Utility Bill" loading={isloading} />
                                </Upload>
                            </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Utility Company",
                                },
                            ]}
                        >
                            <Select_
                                defaultValue="Select Utility Company"
                                // placeholder="Select Utility Company"
                                // className="utility-select"
                                options={isCompanies}
                                name
                                onChange={hanlde}
                            />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
            <Form.Item name="kw">
              <Input placeholder="KWh Consumption" />
            </Form.Item>
          </Col> */}
                    <Col span={24}>
                        <Form.Item
                        
                            name="notes"
                            rules={[
                                {
                                    message: "Please Enter this Field!",
                                },
                            ]}
                        >
                            <TextArea rows={4} placeholder="Notes" />
                        </Form.Item>
                    </Col>
                    {/* {isNoteFilled && (
            <Col span={24}>
              <Alert
                message="Are you sure you want to proceed further without adding a notes"
                type="warning"
                style={{
                  background: "#e6f7ff",
                  borderColor: "#91d5ff",
                  textAlign: "left",
                  marginBottom: 15,
                }}
                action={
                  <Button
                    style={{
                      padding: "0px 10px",
                    }}
                    title="Yes"
                    onClick={() => {
                      setIsNoteFilled(false);
                      setIsAllowedToSubmit(true);
                    }}
                  />
                }
              />
            </Col>
          )} */}
                    <Col span={24}>
                        <Row className="buttons" gutter={[15, 15]}>
                            <Col xs={12} lg={5}>
                                <Button title="Previous" onClick={() => prev()} />
                            </Col>
                            {isNoteFilled ? (
                                <Popover
                                    title="Are you Sure there are no Notes?"
                                    content={
                                        <Row gutter={[15, 15]}>
                                            <Col span={12}>
                                                <Button
                                                    style={{
                                                        padding: "0px 10px",
                                                        marginRight: "10px",
                                                        marginLeft: "30px",
                                                        bottom: "3px",
                                                    }}
                                                    title="No"
                                                    
                                                    onClick={() => {
                                                        setIsNoteFilled(false);
                                                    }}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <Button
                                                    style={{
                                                        padding: "0px 10px",
                                                        marginRight: "10px",
                                                        marginLeft: "30px",
                                                        bottom: "3px"
                                                    }}
                                                    
                                                    title="Yes"
                                                    onClick={() => {
                                                        setIsNoteFilled(false);
                                                        setIsAllowedToSubmit(true);
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    trigger="click"
                                    visible={isNoteFilled}
                                >
                                    <Col xs={12} lg={5}>
                                        <Form.Item>
                                            <Button className="page-change-button" title="Previous"htmlType="submit" />
                                        </Form.Item>
                                    </Col>
                                </Popover>
                            ) : (
                                <Col xs={12} lg={5}>
                                    <Form.Item>
                                        <Button className="page-change-button" title="Next" htmlType="submit" />
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Wrapper>
    );
};

export default AdditionalInformation;
